import { ossPaths } from './paths';

// Plain data: no console, no loader (the entry chunk reads it; route.ts stays lazy).
/** Provider scopes this module serves in the service catalog. */
export const serviceScopes = [
  { scope: 'Internal.Minio', category: 'storage', route: (id: string) => `${ossPaths.base}/${id}` },
  { scope: 'Internal.Minio.Managed', category: 'storage', route: (id: string) => `${ossPaths.base}/${id}` },
] as const;
